import { forceSimulation, forceLink, forceCollide, forceManyBody, forceCenter } from 'd3-force'
import { visibleCanvas, pixelRatio, collideStrength, manyBodyStrength, manyBodyStrengthDistanceMin, manyBodyStrengthDistanceMax, alphaDecay, velocityDecay } from './utils'
import { tick } from './tick'
import * as storage from './storage'

export const simulation = (): void => {
  const nodes: array = storage.nodes()
  const links: array = storage.links()

  globalThis._SIMULATION_ = forceSimulation(nodes)
    .force('link', forceLink(links).id(d => d.id).links(links).distance(d => d.core === true ? d.coreDistance : 0))
    .force('collide', forceCollide().radius(d => d.collisionRadius).strength(collideStrength()))
    .force('charge', forceManyBody().strength(d => manyBodyStrength()).distanceMin(manyBodyStrengthDistanceMin()).distanceMax(manyBodyStrengthDistanceMax()))
    .force('center', forceCenter(visibleCanvas().width / (pixelRatio() * 2), visibleCanvas().height / (pixelRatio() * 2)))
    .alphaDecay(alphaDecay())
    .alphaTarget(0)
    .velocityDecay(velocityDecay())
    .on('tick', () => tick())
}
